import { FC } from 'react';

import { HELP_PAGE_RULES_URL } from 'utils/constants/app';

import publicationRulesLinkClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/cpc_quick/cpc_quick_publication_rules_button_click';
import { Link } from '@hh.ru/magritte-ui';

interface HelpPageLinkProps {
    url: string;
    text: string;
    vacancyId?: number | null;
}

export const HelpPageLink: FC<HelpPageLinkProps> = ({ url, text, vacancyId }) => {
    return (
        <Link
            href={url}
            target="_blank"
            onClick={() => url === HELP_PAGE_RULES_URL && publicationRulesLinkClick({ vacancyId })}
        >
            {text}
        </Link>
    );
};
